import { PathPayload, setValue } from "@/app/common/slicePathUtil";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialState, VATReturnState } from "../statement/varReturnState";

// VAT 신고 관련 Redux Slice 생성
const vatReturnSlice = createSlice({
  name: 'vatReturn',
  initialState,
  reducers: {
    initializeVatReturnState: (state) => {
      return { ...initialState };
    },
    setVatReturnState: (state, action: PayloadAction<VATReturnState>) => {
      return { ...action.payload };
    },
    setVatReturnValue: (state, action: PayloadAction<PathPayload<VATReturnState>>) => {
      setValue(state, action);
    },
  },
});

export const { setVatReturnValue, setVatReturnState, initializeVatReturnState } = vatReturnSlice.actions;
export default vatReturnSlice;